import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import {
    ResponsiveModalWrapper,
    ReplenishmentModalWrapper
} from './ReplenishmentTooltipModalStyles';
import { ReplenishmentTooltipModalSteps } from './ReplenishmentTooltipModalSteps';
import { ReplenishmentTooltipModalHeader } from './ReplenishmentTooltipModalHeader';
import { ReplenishmentTooltipModalFooter } from './ReplenishmentTooltipModalFooter';
import { replenishmentTooltipModalClass } from './utils';

import { ReplenishmentTooltipModalContext } from '~views/ShoppingBagTab/CartSidebarItems/CartItem/ReplenishmentComponent/ReplenishmentTooltipModalContext/ReplenishmentTooltipModalContext';

export const ReplenishmentTooltipModal = observer(() => {
    const { closeModal, isModalOpen } = useContext(ReplenishmentTooltipModalContext);

    return (
        <ResponsiveModalWrapper
            className={replenishmentTooltipModalClass}
            closeModal={closeModal}
            isModalOpen={isModalOpen}
        >
            <ReplenishmentModalWrapper tabIndex={0}>
                <ReplenishmentTooltipModalHeader />
                <ReplenishmentTooltipModalSteps />
                <ReplenishmentTooltipModalFooter />
            </ReplenishmentModalWrapper>
        </ResponsiveModalWrapper>
    );
});
